module.exports = __webpack_public_path__ + "img/shop-by-style-filter-chevy.976d7644.png";